import { useEffect } from 'react';

// The company list (GET /companies/{id}/assessments) omits the heavy feedback
// fields; a report view asks the store for the full record of the one
// assessment it shows. Keyed on the node, not just its id: a full list reload
// recreates the nodes and the new one starts in 'none' again. Fires only in
// 'none', so it cannot loop. A plain object (no detailState) has nothing to
// load and passes straight through. Callers must be mobx observers so the
// state change re-renders them.
export const useAssessmentDetail = (assessment) => {
    const detailState = assessment?.detailState;

    useEffect(() => {
        if (detailState === 'none' && typeof assessment?.ensureDetailLoaded === 'function') {
            assessment.ensureDetailLoaded().catch(() => { /* the node records 'error' */ });
        }
    }, [assessment, detailState]);

    return {
        detailState,
        pending: detailState === 'none' || detailState === 'loading',
        failed: detailState === 'error',
        // Back to 'none' re-arms the effect above.
        retry: () => assessment?.setDetailState?.('none'),
    };
};
